export const filterNonEmpty = <T>(item: T): item is Exclude<T, null | undefined> => Boolean(item)
